// concat a unique ID to the className used in widget to make them dynamic and
// avoid clients from overriding CSS via classnames.

function generateUnid(a) {
  /* eslint-disable no-bitwise */
  return a
    ? (a ^ ((Math.random() * 16) >> (a / 4))).toString(16)
    : ([1e10] + 1e10 + 1e9).replace(/[01]/g, generateUnid).toUpperCase();
  /* eslint-enable no-bitwise */
}

const generateUniqueClassName = className => `${className}-${generateUnid()}`;

export const BEBOT_WIDGET_LOADING_CONTAINER = generateUniqueClassName(
  'bebot-widget-loading-container'
);
export const BEBOT_WIDGET_LOADING_HEAD = generateUniqueClassName('bebot-widget-loading-head');
export const BEBOT_WIDGET_LOADING_CIRCLE = generateUniqueClassName('bebot-widget-loading-circle');
export const BEBOT_ROLLOUT_CONTAINER = generateUniqueClassName('bebot-widget-rollout-container');
export const BEBOT_ROLLOUT_CIRCLE = generateUniqueClassName('bebot-widget-rollout-circle');
export const BEBOT_ROLLOUT_TEXT = generateUniqueClassName('bebot-widget-rollout-text');
export const BEBOT_FIRST_MESSAGE_BADGE = generateUniqueClassName(
  'bebot-widget-first-message-badge'
);
export const BEBOT_ROLLOUT_CLOSE_BUTTON = generateUniqueClassName(
  'bebot-widget-rollout-close-button'
);
export const BEBOT_WIDGET = 'bebot-widget';
export const BEBOT_WIDGET_ACTIVE = generateUniqueClassName('bebot-widget-active');
export const BEBOT_BUBBLE_WRAPPER = generateUniqueClassName('bebot-bubble-wrapper');
export const BEBOT_BUBBLE = generateUniqueClassName('bebot-bubble');
export const TTS_CONTROL_KNOB_ID = generateUniqueClassName('tts-control-knob');
export const TTS_CONTROL_CHECKBOX_ID = generateUniqueClassName('tts-control-checkbox');
export const TTS_CONTROL_KNOB_BG_ID = generateUniqueClassName('tts-control-knob-bg');
